// TODO Verificare se servono cookie, dal vecchio common.js
if (document.cookie.search("token3") == -1) {
	var d = new Date();
	d.setDate(d.getDate() + 14);
	document.cookie = "token3="+(new Date()).getTime()+"; expires="+d.toUTCString()+"; path=/";
}

if (document.cookie.search("token5") == -1) {
	document.cookie = "token5="+btoa(document.referrer);
}

( function( window, document ) {

	function toggleMenu() {
		const nav = document.getElementById( 'header-overlay' );
		if ( ! nav ) {
			return;
		}

		const body = document.body,
		menu = nav.querySelector( 'ul' ),
		button = document.getElementById( 'menu-toggle' );

		menu.setAttribute( 'aria-expanded', 'false' );
		button.addEventListener( 'click', () => {
			if ( nav.classList.contains( 'header-overlay-open' ) ) {
				button.setAttribute( 'aria-expanded', 'false' );
				menu.setAttribute( 'aria-expanded', 'false' );
			} else {
				button.setAttribute( 'aria-expanded', 'true' );
				menu.setAttribute( 'aria-expanded', 'true' );
			}
			body.classList.toggle( 'header-overlay-open' );
		} );
	}

	function stickyHeader() {
		const stickyElem = document.querySelector(".av-sticky-header");

		if (!stickyElem) {
			return;
		}

		var stickyElemHeight = Number( stickyElem.getBoundingClientRect().height );
		var currStickyPos = stickyElem.getBoundingClientRect().top + window.pageYOffset + stickyElemHeight;

		window.addEventListener('scroll', function() {
			if (window.pageYOffset > currStickyPos) {
				stickyElem.classList.add("is-fixed");

			} else {
				stickyElem.classList.remove("is-fixed");
			}
		});
	}

	toggleMenu();
	stickyHeader();

} )( window, document );
